const deleteAreasStr = {
  toastr: 'Tipo de Documentação deletado',
  toastr1: 'deletado com sucesso'
};

export default deleteAreasStr;
